import { createTheme } from "@mui/material/styles";
import { color } from "./shared/styles";

// Create a custom theme
const theme = createTheme({
    typography: {
        fontFamily: '"Noto Sans", sans-serif',
    },
    
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                    textTransform: "none",
                    fontSize: "16px",
                    fontFamily: "Noto Sans",
                    paddingLeft: "24px",
                    paddingRight: "24px",
                    wordWrap: "break-word",
                    lineHeight: "normal",
                    height: "40px",
                    width: "auto",
                    minWidth: "auto",
                    boxSizing: "border-box",
                },
                contained: {
                    backgroundColor: color.button.PRIMARY,
                    "&:hover": {
                        backgroundColor: color.button.HOVER,
                    },
                },
                outlined: {
                    border: `1px solid ${color.primary.BLUE_B100}`,
                    "&:hover": {
                        backgroundColor: color.status.INFO_LIGHT,
                    },
                },
                text: {
                    color: "black",
                    border: `1px solid ${color.secondary.BORDER}`,
                    borderRadius: "10px",
                },
            },
        },
    },
    palette: {
        primary: {
            main: color.primary.BLUE_B100,
        },
    },
});

export default theme;
